import { Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import api from '@/api/index';
import { useAudioStore } from '@/stores/audio';
import { useCallStore } from '@/stores/call';
import { useChatPreferenceStore } from '@/stores/chatPreference';
import { useSocketStore } from '@/stores/socket';
import { useUserStore } from '@/stores/user';
import { ConnectionInfo } from '@/types/socket';
import { getBrowserAndDeviceInfo } from '@/utils/device';
import { base64UrlSafeToString } from '@/utils/encryptor.js';

export function useSocketScreen(chatId: Ref<string>) {
  const route = useRoute();
  const router = useRouter();
  const callStore = useCallStore();
  const socketStore = useSocketStore();
  const userStore = useUserStore();
  const audioStore = useAudioStore();
  const chatPreferenceStore = useChatPreferenceStore();

  const connectToWebsocket = async () => {
    const { code } = route.query;
    const resultQR = await api.get(`/api/qr/${code}`);
    if (!resultQR.data.options?.screenMode || code === resultQR.data.hostCode) {
      await router.push({ name: 'error-not-found' });
    }

    callStore.setQrCodeInfo(resultQR.data);
    const guestCode = resultQR.data.guestCode;

    let testerInfo = null; // 테스터 계정 정보
    const userInfoLocalStorage = localStorage.getItem('userInfo');
    if (userInfoLocalStorage) {
      const userInfoParsed = JSON.parse(userInfoLocalStorage);
      if (userInfoParsed.isTester) testerInfo = userInfoParsed;
    }
    const { data: resultUserInfo } = await api.get('/api/user/info/web', {
      headers: {
        'NO-AUTHORIZATION-TOKEN': '1',
      },
    });
    const resultNext = await api.get(`/api/chat/business/call/${guestCode}/next`, {
      responseType: 'text',
    });
    chatId.value = resultNext.data;
    sessionStorage.setItem('userId', resultUserInfo.userId); //임시 추가, 언어변경시 이걸 사용하므로 변수로 빼면 좋을듯
    const agent = JSON.stringify(getBrowserAndDeviceInfo()); // 사용자 브라우저 및 장치 정보
    const { isTester, userType, userId } = resultUserInfo;
    userStore.userInfo = {
      ...resultUserInfo,
      nickname: base64UrlSafeToString(resultUserInfo.nickname),
      isTester: testerInfo ? true : resultUserInfo.isTester,
    };
    userStore.isTester = testerInfo ? true : isTester;
    userStore.userType = userType;
    userStore.userId = userId;

    const connectionInfo: ConnectionInfo = {
      userId: resultUserInfo.userId,
      token: `SC-USER-ID ${resultUserInfo.webTokenResponse.value}`,
      isRegister: '0',
      isTssOn: '0',
      voiceId: '0',
      chatId: resultNext.data,
      languageCode: chatPreferenceStore.screenPreference.languageCode ?? userStore.pageLanguage,
      nickname: resultUserInfo.nickname,
      isPartnerPerson: '0',
      longVoice: '0',
      evictMySelf: '1',
      code: resultQR.data.guestCode,
      callType: resultQR.data.callType,
      connectionType: 'SCREEN',
      agent,
    };
    socketStore.setConnectInfo(connectionInfo);
    socketStore.setupWebSocket();
  };
  return {
    connectToWebsocket,
  };
}
